$(document).on('click', '.link-coupon', function() {
  var $this = $(this);
  var coupon_id = $this.attr('data-id');
  if (parseInt(coupon_id) > 0) {
    $.ajax({
      url: 'index.php?route=account/coupon/getCoupon&coupon_id=' + coupon_id,
      type: 'get',
      beforeSend: function() { show_load(); },
      complete: function() { hide_load(); },
      dataType: 'json',
      success: function(json) {
        if (json['error'])
          if(json['error'] === '获取优惠券失败，请先登录'){
            layer.open({
              type: 1,
              title: '提示',
              area: ['280px', '115px'], //宽高
              content: '<div style="text-align: center; padding-top: 20px;">获取优惠券失败，请先<a href="https://eshop.dellemc-solution.com/account/login" target="_blank" style="color:darkred; text-decoration:underline; font-size: 13px;">登录</a></div>'
            });
          }else{
            layer.msg(json['error']);
          }
      }
    });
  }
});